import { render, staticRenderFns } from "./VacancyStage.vue?vue&type=template&id=456cf88c&scoped=true"
import script from "./VacancyStage.vue?vue&type=script&lang=js"
export * from "./VacancyStage.vue?vue&type=script&lang=js"
import style0 from "./VacancyStage.vue?vue&type=style&index=0&id=456cf88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456cf88c",
  null
  
)

export default component.exports